import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiCheck } from "react-icons/fi";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/paysuccess.css";

function PaySuccess() {
  const { state } = useLocation();
  const [fallbackOrder] = useState(
    () => `${siteConfig.orderPrefix}-${Date.now().toString().slice(-8)}`
  );
  const orderNumber = state?.orderNumber || fallbackOrder;

  return (
    <main className="success-page">
      <div className="success-page__mark" aria-hidden="true"><FiCheck /></div>
      <p className="eyebrow">ORDER CONFIRMED</p>
      <h1>Thank you.<br />Your order is on its way.</h1>
      <p className="success-page__message">
        We have sent the confirmation to <strong>{state?.email || "your email address"}</strong>.
        You will receive another note as soon as your parcel leaves our atelier.
      </p>
      <dl className="success-page__details">
        <div><dt>Order</dt><dd>{orderNumber}</dd></div>
        {state?.total != null && <div><dt>Total</dt><dd>{formatPrice(state.total)}</dd></div>}
        <div><dt>Delivery</dt><dd>3–5 business days</dd></div>
      </dl>
      <div className="success-page__actions">
        <Link className="button button--dark" to="/shop">Continue shopping</Link>
        <Link className="text-link" to="/contact">Need help?</Link>
      </div>
    </main>
  );
}

export default PaySuccess;
